import styled, { css } from 'styled-components';

export const Cards = styled.div`
  gap: 24px;
  display: grid;
  grid-template: ${({ theme }) =>
    theme.responsive.isMobile ? '1fr / 1fr' : '1fr 1fr / 1fr 1fr'};
`;

export const CardContainer = styled.div`
  gap: 16px;
  display: flex;
  align-items: center;
  ${({ theme }) =>
    theme.responsive.isMobile
      ? css`
          svg {
            width: 48px;
            height: 48px;
          }
        `
      : css`
          flex-direction: column;
          justify-content: center;
        `}
`;
